export enum OverlayColor {
  'blue' = '#2E5FDC',
  'green' = '#24933C',
  'yellow' = '#c3e85c',
}

export enum DebugColor {
  LightGreen = '#8bc34a',
  Blue = '#2196f3',
  DeepOrange = '#ff5722',
  Yellow = '#ffeb3b',
  LightBlue = '#03a9f4',
  Teal = '#009688',
  Purple = '#9c27b0',
  Amber = '#ffc107',
  Indigo = '#3f51b5',
  Green = '#4caf50',
  Lime = '#cddc39',
  Red = '#f44336',
  Pink = '#e81e63',
  Cyan = '#00bcd4',
  Orange = '#ff9800',
  DeepPurple = '#673ab7',
}
